import React from "react";
import {useSelector} from "react-redux";
import {selectStripeAccountErrors, selectStripeAccountLink} from "../../../store/selectors/Profile";

const StripeVerify = () => {
  const stripeAccountErrors = useSelector(selectStripeAccountErrors);
  const stripeAccountLink = useSelector(selectStripeAccountLink);
  return (
    <>
      {stripeAccountErrors ?
        <div className={"topStripeBox"}>
          <h1 className="EMPHASIS_LARGE">{`Your Stripe account is not verified yet`}</h1>
          <h2 className="EMPHASIS_MEDIUM">{`You must verify your account before you can pay out. `}
            <a href={stripeAccountLink} target="blank" className="EMPHASIS_MEDIUM">{'Verify now.'}</a>
          </h2>
        </div> :
        <></>
      }
    </>
  );
}

export default StripeVerify;
